/* eslint-disable no-undef */
import React, {Component} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    Button,
} from '@material-ui/core';

const styles = theme => ({
    alertButton: {
        width: '100%',
        marginBottom: 10,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        color: 'white'
    },
    rightIcon: {
        marginLeft: 10,
        marginRight: -15,
        [theme.breakpoints.down(430)]: {
            display: 'none'
        },
    },
    title: {
        marginTop: theme.spacing(1)+'px!important'
    }
});

class Alert extends Component {
    state = {value: null}

    render() {
        const {alert, onClose, classes} = this.props;
        return (
            <Dialog onClose={onClose} open={!!alert}>
                <DialogTitle disableTypography><Typography variant={'h5'}
                                                           className={classes.title}>{alert.title}</Typography></DialogTitle>
                <DialogContent>
                    <DialogContentText variant={'body2'}>
                        {alert.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" variant="contained"
                            className={classes.alertButton+' forwardButton'}>
                        {alert.buttonText}
                        <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                         icon={['far', 'arrow-alt-circle-right']}/>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(Alert);
